/**
 * Resource danh mục tài khoản Ngân hàng, Kho bạc
 * ndhieu3 20.04.2023
 */
export default {
  BankInfo: {
    Bank: 'Ngân hàng',
  },
  BankInfoDetail: {
    AccountNumber: 'Số tài khoản *',
    OpenBank: 'Mở tại Kho bạc',
    BankCode: 'Mã ngân hàng, kho bạc',
    BankName: 'Tên Kho bạc *',
    AccountCategory: 'Loại tài khoản',
  },
};
